import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MoonIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M12.897 2.557c.268.208-.035.62-.373.552A5.458 5.458 0 0 0 11.434 3C8.555 3 6 5.239 6 8s2.553 5 5.435 5c.373 0 .738-.038 1.09-.11.337-.068.64.345.372.553A7.472 7.472 0 0 1 8.304 15C4.27 15 1 11.866 1 8s3.27-7 7.304-7c1.74 0 3.339.583 4.593 1.557Z"
		/>
		<path
			fill="currentColor"
			d="M9.12 8.195a.218.218 0 0 1 0-.39l.426-.212a4.577 4.577 0 0 0 2.046-2.047l.213-.426c.08-.16.31-.16.39 0l.213.426a4.577 4.577 0 0 0 2.046 2.047l.425.212c.161.08.161.31 0 .39l-.425.212a4.577 4.577 0 0 0-2.046 2.047l-.213.425c-.08.161-.31.161-.39 0l-.213-.425a4.577 4.577 0 0 0-2.046-2.047l-.426-.212Z"
		/>
	</svg>
))
